<script setup>
import { computed, onMounted, ref } from "vue";

const props = defineProps({
	pricing: {
		type: Array,
		required: true,
	},
	basePrice: {
		type: Number,
		required: true,
	},
	ctasDescription: {
		type: String,
	},
	phoneCta: {
		type: String,
	},
	phoneNumber: {
		type: Number,
	},
	formCta: {
		type: String,
	},
	formShortcode: {
		type: String,
	}
});

const popup = ref(null);
const popupClosers = ref(null);

const calculatePricePercentageDifference = (discountedPrice) =>
	computed(() => {
		const percentageDifference =
			((props.basePrice - discountedPrice) / props.basePrice) * 100;
		return Math.round(percentageDifference) + "%";
});

const handleFormOpen = () => {
	if (!popup.value) return;
	popup.value.classList.add('is-active');
};

onMounted(() => {
	popup.value = document.querySelector('.js-form-popup');
  popupClosers.value = document.querySelectorAll('.js-popup-close');

	if (popupClosers.value) {
		popupClosers.value.forEach(closer => {
			closer.addEventListener('click', function() {
				popup.value.classList.remove('is-active');
			});
		});
	}
});
</script>

<template>
	<div class="u-flex u-wrap u-no-wrap@ipad u-gap-half u-my">
		<div class="u-flex-even@ipad" v-for="(item, index) in pricing" :key="index">
			<div class="u-flex u-h-center u-mb-quarter">
				<span v-if="item.min_quantity"
					>{{ item.min_quantity }}<span v-if="!item.max_quantity">+</span></span
				>
				<span v-if="item.max_quantity">-{{ item.max_quantity }}</span>
			</div>

			<span class="c-card c-card--grey c-card--rounded u-p-quarter u-tac"
				>&pound;{{ (basePrice - item.discount).toFixed(2) }}</span
			>

			<template v-if="index !== 0">
				<span class="u-block u-tac u-mt-half u-font-colour-green u-font-small">
					Save
					{{ calculatePricePercentageDifference(basePrice - item.discount) }}
				</span>
			</template>
		</div>
	</div>
	<div class="c-product__ctas u-mt-2x u-width-1/1" v-if="(phoneCta && phoneNumber) || (formCta && formShortcode)">
		<div class="u-font-bold u-font-colour-secondary e-heading--five" v-if="ctasDescription">{{ ctasDescription }}</div>
		<div class="u-flex u-gap u-wrap u-mt">
			<a :href="'tel:' + phoneNumber" class="u-flex u-v-center u-h-center e-btn" v-if="phoneCta && phoneNumber"><ion-icon name="call-outline" class="u-mr-quarter" />{{ phoneCta }}</a>
			<span class="u-flex u-v-center u-h-center u-pointer js-form-trigger e-btn" v-if="formCta && formShortcode" @click="handleFormOpen"	><ion-icon name="mail-outline" class="u-mr-quarter" />{{ formCta }}</span>
		</div>
	</div>
</template>
